/** A handful of line icons drawn for Hexling (24px grid, currentColor). */
const PATHS = {
  today: "M12 3a9 9 0 1 0 9 9 7 7 0 0 1-9-9Z",
  library: "M4 4h5v16H4zM10 4h4v16h-4zM15.5 5.2l3.9-1 3.6 15-3.9 1z",
  calendar: "M4 6h16v14H4zM4 10h16M8 3v4M16 3v4",
  lessons: "M3 7l9-4 9 4-9 4zM7 9v5c3 2 7 2 10 0V9M21 7v6",
  grimoire:
    "M6 3h11a2 2 0 0 1 2 2v16H7a2 2 0 0 1-2-2V4a1 1 0 0 1 1-1zM5 17a2 2 0 0 1 2-2h12M10 7h5",
  bookmark: "M6 3h12v18l-6-4-6 4z",
  list: "M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01",
  note: "M4 20h4l11-11-4-4L4 16zM13.5 6.5l4 4",
  flag: "M5 21V4M5 4h11l-2 4 2 4H5",
  search: "M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zM16 16l5 5",
  back: "M15 5l-7 7 7 7",
  sync: "M4 12a8 8 0 0 1 14-5l2 2M20 12a8 8 0 0 1-14 5l-2-2M20 4v5h-5M4 20v-5h5",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({
  name,
  size = 22,
  filled = false,
}: {
  name: IconName;
  size?: number;
  filled?: boolean;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      fill={filled ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
